import { logger } from '../logger';

/**
 * Logger for CRM-related operations
 * Use this for contacts, companies, deals, and CRM integrations
 */
const crmLogger = logger.child('CRM');

export default crmLogger;
